import { APP_INITIALIZER, ErrorHandler, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FilterComponent } from '../component/filter/filter.component';
import { FilterPipe } from '../component/filter/filter.pipe';
import { TextFilterPipe } from '../service/textFilter.pipe';
import { Daterangepicker } from 'ng2-daterangepicker';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DashboardComponent } from '../component/dashboard/dashboard.component';
import { HeaderComponent } from '../component/header/header.component';
import { LeftMenuComponent } from '../component/left-menu/left-menu.component';
import { RouterModule } from '@angular/router';
import { BreakingNewsListingComponent } from '../component/breaking-news-listing/breaking-news-listing.component';
import { AngularMultiSelectModule } from 'angular2-multiselect-dropdown';
import { AngularCropperjsModule } from 'angular-cropperjs';
import { ImageCropperComponent } from '../component/image-cropper/image-cropper.component';
import { PhotoListingComponent } from '../component/photo-listing/photo-listing.component';
import { ListingComponent } from '../component/listing/listing.component';
import { DragulaModule } from 'ng2-dragula';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { PdfJsViewerModule } from 'ng2-pdfjs-viewer';
import { NuberInputDirective } from '../directive/nuber-input.directive';
import { TwoDigitDecimaNumberDirective } from '../directive/two-digit-decima-number.directive.directive';
import { DeferLoadDirective } from '../service/defer-load.directive';
import { IframeTrackerDirective } from '../service/iframe-tracker.directive';
import { RelatedStoryListingComponent } from '../component/related-story-listing/related-story-listing.component';
import { PageTypeListingComponent } from '../component/page-type-listing/page-type-listing.component';
import { AllElementListingComponent } from '../component/all-element-listing/all-element-listing.component';
import { CKEditorModule } from '@ckeditor/ckeditor5-angular';
import { QuillModule } from 'ngx-quill';
import { NewMetadataComponent } from '../component/new-metadata/new-metadata.component';
import { TagsCreatorComponent } from '../component/tags-creator/tags-creator.component';
import { PageListingComponent } from '../component/page-listing/page-listing.component';
import { MatchComponentComponent } from '../component/match-component/match-component.component';
import { TemplateComponent } from '../component/template/template.component';
import { ZoneViewComponent } from '../component/zone-view/zone-view.component';
import { ZoneListingComponent } from '../component/zone-listing/zone-listing.component';
import { NoSanitizePipe } from '../service/noSanitizePipe.pipe';
import { AllWireFeedListingComponent } from '../component/all-wire-feed-listing/all-wire-feed-listing.component';
import { OwlDateTimeModule, OwlNativeDateTimeModule } from 'ng-pick-datetime';
import { CarouselModule } from 'ngx-owl-carousel-o';
@NgModule({
  imports: [
    CommonModule,
    Daterangepicker,
    RouterModule,
    AngularMultiSelectModule,
    AngularCropperjsModule,
    DragulaModule,
    InfiniteScrollModule,
    PdfJsViewerModule,
    FormsModule,ReactiveFormsModule,
    OwlDateTimeModule,
    OwlNativeDateTimeModule,
    CarouselModule
    // //pages and story container
    // CKEditorModule,
    // QuillModule
  ],
  declarations: [
    // AllElementListingComponent,
    FilterComponent,
    FilterPipe,
    TextFilterPipe,
    NoSanitizePipe,
    // // Part Of Dashboard//
    // DashboardComponent,
    HeaderComponent,
    LeftMenuComponent,
    // //............................//
    // //Part Of Header//
    BreakingNewsListingComponent,
    ImageCropperComponent,
    PhotoListingComponent,
    ListingComponent,
    AllWireFeedListingComponent,
    // RelatedStoryListingComponent,
    // //...........................//
    // //Directives//
    // IframeTrackerDirective,
    // DeferLoadDirective,
    // NuberInputDirective,
    // TwoDigitDecimaNumberDirective,
    // // .........................//

    // //common for page & story container//
     TagsCreatorComponent,
    // NewMetadataComponent,
    // PageListingComponent,
    // MatchComponentComponent,
    // //.................................//

  ],
  exports: [
  //  AllElementListingComponent,
    FilterComponent,
    FilterPipe,
    TextFilterPipe,
    Daterangepicker,
    NoSanitizePipe,
    // DashboardComponent,
    HeaderComponent,
    LeftMenuComponent,
    AllWireFeedListingComponent,
    BreakingNewsListingComponent,
    ImageCropperComponent,
    // RelatedStoryListingComponent,
    PhotoListingComponent,
    ListingComponent,
    DragulaModule,
    InfiniteScrollModule,
    PdfJsViewerModule,
    AngularMultiSelectModule,
    // FormsModule,ReactiveFormsModule,
    // CKEditorModule,
    // QuillModule,
  //  IframeTrackerDirective,
  //  DeferLoadDirective,
  //  NuberInputDirective,
  //  TwoDigitDecimaNumberDirective,
    TagsCreatorComponent,
  //  NewMetadataComponent,
  //  PageListingComponent,
  //  MatchComponentComponent,
  FormsModule,ReactiveFormsModule

  ]



})
export class SharedModule { }
